import HttpService from "@/hooks/Https-services";
import useConfig from "../../../hooks/useConfig";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import PageRoutes, { APIRoutes } from "@/utils/constants";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
const ButtonCondencedGame = ({ game }: { game: any }) => {
  const configData = useConfig();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const CheckCondenedGame = async () => {
    try {
      setLoading(true);
      const res = await HttpService.post(APIRoutes.CondensedGame, {
        game_id: game.game_id,
      });
      if (res?.data?.data) {
        const contentId = res?.data?.data?.ID;
        navigate(PageRoutes.ShortView.replace(":id", contentId));
        setLoading(false);
      } else {
        toast.error("Condensed Game Not Available");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error("Condensed Game Not Found");
    }
  };
  return (
    <LoadingButton
      className="card-footer-button"
      sx={{
        color: configData.primary,
        display: "flex",
        alignItems: "center",
        width: "auto",
        justifyContent: "center",
        backgroundColor: "#fff",
        fontSize: 12,
        fontWeight: 500,
        "&:hover": {
          backgroundColor: "#fff",
          color: configData.primary,
        },
      }}
      onClick={CheckCondenedGame}
      loading={loading}
    >
      <PlayCircleFilledWhiteOutlinedIcon /> CONDENSED
    </LoadingButton>
  );
};
export default ButtonCondencedGame;
